import { useState, useEffect } from 'react';
import { generateClient } from 'aws-amplify/api';
import { useNavigate } from "react-router-dom";
import { Card } from 'semantic-ui-react';
import { listTransactionSetupTables } from '../graphql/queries';

const client = generateClient();

function Setups() {
  // set state
  const navigate = useNavigate();
  const [setupInfo, setSetupInfo] = useState([]);
  // first data grab
  useEffect(() => {
    async function fetchData() {
      //const result = await DataStore.query(TransactionSetupTable);
      const result = await client.graphql({ query: listTransactionSetupTables });
      if (result) {
        result.data.listTransactionSetupTables.items.sort(dynamicSort("ExternalId"));
        setSetupInfo(result.data.listTransactionSetupTables.items);
      }
    }

    fetchData();
  }, []);

  function dynamicSort(property) {
    var sortOrder = 1;
    if (property[0] === "-") {
      sortOrder = -1;
      property = property.substr(1);
    }
    return function (a, b) {
      var result = (a[property] < b[property]) ? -1 : (a[property] > b[property]) ? 1 : 0;
      return result * sortOrder;
    }
  }

  const openSetup = (id) => {
    if (id) {
      navigate('/setup/' + id, { replace: true });
    }
    else {
      navigate('/setup/', { replace: true });
    }
  }

  return (
    <Card.Group>
      <Card key="newTop" onClick={() => openSetup()}>
        <Card.Content>
          <Card.Header>Add New</Card.Header>
          <button>Edit</button>
        </Card.Content>
      </Card>
      {setupInfo.map(tData => {
        return (
          <Card key={tData.id} onClick={() => openSetup(tData.id)}>
            <Card.Content>
              <Card.Header>{tData.ExternalId}</Card.Header>
              <div>{tData.WeightMap}</div>
              <div>{tData.ImageMap}</div>
              <button>Edit</button>
            </Card.Content>
          </Card>);
      })}
      <Card key="newBottom" onClick={() => openSetup()}>
        <Card.Content>
          <Card.Header>Add New</Card.Header>
          <button>Edit</button>
        </Card.Content>
      </Card>
    </Card.Group>
  );
}

export default Setups